import React, { useState } from "react";
import { Steps, Button, Upload, message, Row, Space } from "antd";
import imgStart from "./images/cuate.svg";
import { UploadOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import axios from "axios";
import stoolImg from "./StoolSampleImg";
// import { API_STOOL } from "../../constants";
import StoolAi from "./StoolAi";
import getBase64 from "../Common/GetBase64";
import StoolResults from "./StoolResults";

const newApiUrl =
    "https://digital-health-services-apac-beta.hive.digital4danone.com/beta/early-life/v1/stool-tracker?guestapicall=true";

const stepItems = [
    {
        title: "Start",
    },
    {
        title: "Upload Photo",
    },
    {
        title: "AI Inferences",
    },
    {
        title: "Results And Insights",
    },
];

const { Dragger } = Upload;

const payload = {
    // child_age_months: "3.5",
    detect_color: true,
    detect_diaper: true,
    detect_score: true,
    photo: stoolImg,
    profile_data: {
        gender: "M",
        date_of_birth: "18-Aug-2023",
        feeding_mode: "BreastFeeding",
        formula_name: "Aptamil Stage 1",
    },
    consent_data_usage: "yes",
};

function StoolInference() {
    const [currentStep, setCurrentStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const [aiInferences, setAiInferences] = useState(null);

    const nextStep = () => {
        setCurrentStep((currentStep) => currentStep + 1);
    };

    const backStep = () => {
        setCurrentStep((currentStep) => currentStep - 1);
        setAiInferences(null);
    };

    const useSamplePhoto = () => {
        setLoading(true);

        axios
            .post(newApiUrl, payload, {
                headers: {
                    // "x-api-key": "DLAB-TestUserOne-12345687",
                    dapm_key: "DH-API-DemoSite-0001",
                },
            })
            .then((response) => {
                response.data.data.photoBase64 =
                    "data:image/jpg;base64," + stoolImg;
                setAiInferences(response.data.data);
                setLoading(false);
                nextStep();
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const handleUploadImage = (file) => {
        const isJpgOrPng =
            file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            message.error("You can only upload JPG/PNG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error("Image must smaller than 2MB!");
        }

        if (isJpgOrPng && isLt2M) {
            getBase64(file)
                .then((result) => {
                    let photoUpload = result.replace(
                        /^data:image\/[a-z]+;base64,/,
                        ""
                    );
                    // console.log(photoUpload);
                    payload.photo = photoUpload;

                    setLoading(true);

                    axios
                        .post(newApiUrl, payload, {
                            headers: {
                                // "x-api-key": "DLAB-TestUserOne-12345687",
                                dapm_key: "DH-API-DemoSite-0001",
                            },
                        })
                        .then((response) => {
                            response.data.data.photoBase64 = result;
                            setAiInferences(response.data.data);
                            setLoading(false);
                            nextStep();
                        })
                        .catch((error) => {
                            console.log(error);
                            setLoading(false);
                        });
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        return false;
    };

    const handleChangeResultType = (value, score) => {
        setAiInferences((prevState) => ({
            ...prevState,
            consistency: value,
            score: score,
        }));
    };

    const handleChangeResultColor = (value) => {
        setAiInferences((prevState) => ({
            ...prevState,
            color: value,
        }));
    };

    const showResults = () => {
        nextStep();
    };

    const startAgain = () => {
        setCurrentStep(0);
        setAiInferences(null);
    };

    return (
        <>
            <div className="wrap-block">
                <Steps
                    labelPlacement="vertical"
                    current={currentStep}
                    items={stepItems}
                    size="small"
                />
            </div>

            {currentStep === 0 && (
                <div className="wrap-block app-text-center">
                    <div className="app-title">Stool Inference</div>
                    <img
                        src={imgStart}
                        alt=""
                        width={244}
                        style={{ marginBottom: 16 }}
                    />
                    <p className="app-text-16">
                        Is your child having Diarrhea or Constipation?
                    </p>
                    <p className="app-text-16">
                        Take a picture and let our AI Poop Checker give you care
                        advice.
                    </p>
                    <Button
                        type="primary"
                        size="large"
                        onClick={() => nextStep()}
                        className="app-btn-primary full-width-mobile"
                    >
                        Start
                    </Button>
                </div>
            )}

            {currentStep === 1 && (
                <div className="wrap-block app-text-center">
                    <div className="wrap-btn">
                        <Button
                            type="link"
                            onClick={() => backStep()}
                            className="app-btn-back"
                        >
                            <ArrowLeftOutlined />
                            Back
                        </Button>
                    </div>
                    <div className="app-title">
                        Simply snap a picture of your child's poop and upload
                        it!
                    </div>
                    <Space
                        direction="vertical"
                        style={{ width: "100%" }}
                        size="large"
                    >
                        <Dragger
                            multiple={false}
                            showUploadList={false}
                            beforeUpload={handleUploadImage}
                            disabled={loading}
                        >
                            <p className="ant-upload-drag-icon">
                                <UploadOutlined />
                            </p>
                            <p className="ant-upload-text">
                                Click or drag file to this area to upload
                            </p>
                            <p className="ant-upload-hint">Or</p>
                        </Dragger>
                        <Button
                            onClick={useSamplePhoto}
                            className="app-btn-secondary"
                            loading={loading}
                        >
                            Use Sample Photo
                        </Button>
                        <p className="app-text-16">
                            Please upload a photo or use the sample photo to
                            proceed.
                        </p>
                    </Space>
                </div>
            )}

            {currentStep === 2 && (
                <div className="wrap-block">
                    <div className="wrap-btn">
                        <Button
                            type="link"
                            onClick={() => backStep()}
                            className="app-btn-back"
                        >
                            <ArrowLeftOutlined />
                            Back
                        </Button>
                    </div>
                    <div className="app-title app-text-center">
                        AI Inferences
                    </div>
                    {aiInferences && (
                        <StoolAi
                            aiInferences={aiInferences}
                            handleChangeResultType={handleChangeResultType}
                            handleChangeResultColor={handleChangeResultColor}
                        />
                    )}
                    <Row justify="center">
                        <Button
                            type="primary"
                            onClick={showResults}
                            className="app-btn-primary full-width-mobile"
                            disabled={aiInferences.diaper === "not detected"}
                        >
                            Show Result
                        </Button>
                    </Row>
                </div>
            )}

            {currentStep === 3 && (
                <div className="wrap-block app-text-center">
                    <div className="app-title">Results And Insights</div>
                    {aiInferences && <StoolResults {...aiInferences} />}
                    <Button
                        type="primary"
                        onClick={startAgain}
                        className="app-btn-primary full-width-mobile"
                    >
                        Start Again
                    </Button>
                </div>
            )}
        </>
    );
}

export default StoolInference;
